export const PAGE_FIX_DOMAIN_SETTINGS_MODULE: Record<string, string> = {
    SPELLING_ERROR: 'spelling_error',
    ACCESSIBILITY_SOURCE_CODE: 'accessibility_source_code',
    ACCESSIBILITY_CHECK: 'accessibility_check',
    LINK: 'link',
    CUSTOM: 'custom',
};
